exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-listings-js": () => import("./../../../src/pages/listings.js" /* webpackChunkName: "component---src-pages-listings-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-rental-js": () => import("./../../../src/templates/rental.js" /* webpackChunkName: "component---src-templates-rental-js" */)
}

